// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://vyhlbveplfyzarnucunt.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InZ5aGxidmVwbGZ5emFybnVjdW50Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTYwNjcwNTYsImV4cCI6MjA3MTY0MzA1Nn0.Yi6Wxe7dTV5zSD2PfhKfIvHjM5bT7W-AUQjpITLekRg";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
  }
});